/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon20Regular = forwardRef('MediaAudioVolumeSMinusIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 3.12c0-.983-1.152-1.513-1.898-.874L4.722 6H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.723l4.379 3.753c.746.64 1.898.11 1.898-.873V3.12ZM5.629 7.199 9.5 3.881v12.238l-3.871-3.318a1.25 1.25 0 0 0-.814-.301H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h2.815c.298 0 .587-.107.814-.301Z" }),
        React.createElement("path", { d: "M13.25 9.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-5.5Z" })));
});
